import React from 'react';

import VrmChecker, { VrmCheckerBase, VrmCheckerBaseProps } from '../VrmChecker/VrmChecker';
import VrmUlezChecker from '../VrmUlezChecker/VrmUlezChecker';

export const VrmCheckerFooter = (
  {
    ref,
    useUlezVrmChecker = false,
    ...props
  }: Partial<VrmCheckerBaseProps> & { ref?: React.Ref<VrmCheckerBase>; useUlezVrmChecker?: boolean },
) => (useUlezVrmChecker ? <VrmUlezChecker hideErrors inFooter /> : <VrmChecker ref={ref} {...props} />);
